import React from "react";
var __jsx = React.createElement;
export default function IconL() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#clip0_6559_5165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36473 11.5575C5.51788 11.6079 5.12672 12.0261 5.24858 12.3296C5.37145 12.6331 6.23468 13.3954 7.68568 13.5991C9.13567 13.8028 10.5713 13.7098 11.1191 13.7098C11.6659 13.7098 12.3131 13.6347 11.9793 13.3588C11.2031 12.7486 10.3207 12.2766 9.37323 11.9648C8.1004 11.5565 7.21056 11.5051 6.36473 11.5565V11.5575ZM3.35008 7.92304C3.40742 8.277 3.78733 9.17868 4.88301 9.86286C5.7534 10.4086 6.74668 10.7991 7.80447 11.0087C8.58988 11.1689 9.33226 11.3874 9.08651 10.9425C8.84076 10.4976 8.00926 9.39322 6.80709 8.6171C5.60491 7.84099 4.97105 7.74904 4.43654 7.64028C3.90098 7.53153 3.29272 7.57108 3.35006 7.92404L3.35008 7.92304ZM3.71872 4.26491C3.27737 4.26491 3.30707 4.6584 3.42484 4.99655C3.54362 5.33269 4.04845 6.33621 4.91987 6.94721C5.50149 7.35356 6.23776 7.70653 7.12863 8.00511C6.92998 6.91261 6.50398 6.05345 5.85068 5.4286C4.87173 4.49032 4.16007 4.2659 3.71872 4.2659V4.26491ZM5.6981 1.35224C5.55599 1.33897 5.41356 1.37432 5.29568 1.4521C5.24169 1.48719 5.19599 1.5329 5.16158 1.58623C5.12717 1.63956 5.10482 1.69931 5.096 1.76156L5.07756 1.93557C5.02842 2.49516 5.11851 3.05673 5.34073 3.58668C5.67865 4.38751 6.18655 5.02323 6.86238 5.48989C6.9955 5.06278 7.07845 4.70884 7.10814 4.42607C7.1532 4.00093 7.1532 3.61732 6.86239 2.64742C6.73337 2.21635 6.45279 1.82681 6.02272 1.4788C5.93035 1.40576 5.81711 1.36161 5.6981 1.35224Z",
    fill: "url(#paint0_linear_6559_5165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9414 0.140708C8.04059 0.142217 8.1413 0.174984 8.22594 0.233292C8.29738 0.2812 8.35386 0.345376 8.38785 0.417269C8.5435 0.756171 8.592 1.06302 8.53206 1.33708C8.39752 1.95388 8.2723 2.15632 8.10532 2.36439C7.99443 2.50289 7.82696 2.65972 7.60421 2.83705C7.33343 2.34681 7.22298 1.82798 7.27284 1.28339C7.3067 0.923514 7.43361 0.594648 7.64704 0.317092L7.71538 0.231925C7.74122 0.202258 7.77472 0.178795 7.81367 0.163075C7.85262 0.147356 7.89615 0.139733 7.9414 0.140708Z",
    fill: "url(#paint1_linear_6559_5165)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6559_5165",
    x1: "8.2591",
    y1: "28.9202",
    x2: "-2.1139",
    y2: "-4.60126",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#E7D2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.371018",
    "stop-color": "#E5C28F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.870192",
    "stop-color": "#A96500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6559_5165",
    x1: "8.2591",
    y1: "28.9202",
    x2: "-2.1139",
    y2: "-4.60126",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#E7D2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.371018",
    "stop-color": "#E5C28F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.870192",
    "stop-color": "#A96500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6559_5165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "15.3529",
    height: "14.8235",
    fill: "white"
  }))));
}
IconL.displayName = "IconL";